const PictViewClass = require('pict-view');

class LIMSLocationRecordEdit extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;

		this.AppData.LocationDetails = {};
		this.ActiveLocationLogs = [];
		this.LIMSLocationRecordBackTo = null;
		this.manifest = require('./defaultLocationEditManifest.json');
	}

	async onBeforeRenderAsync(pCallback, pRenderable)
	{
		this.AppData.LocationDetails = {};
		const session = await this.pict.providers.SessionProvider.getSession();
		this.pict.PictApplication.changeTheme('Edit');
		if (!this.initialized || (session.CustomerID !== this.customer))
		{
			this.customer = session.CustomerID;
			// Check for a manifest from the DB before loading the default.
			const remoteManifest = await this.pict.ManifestPackagingService.loadRecordManifestSchema('Location', 'Edit', this.pict.PictApplication.options.pict_configuration.Product);
			this.manifest = remoteManifest || this.manifest;
			this.pict.views.PictFormMetacontroller.clearManifestDescription();
			this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(this.manifest);
			this.pict.views['PictSectionForm-LocationEdit'].viewMarshalDestination = 'AppData';
			this.pict.views['PictSectionForm-LocationEdit'].options.DefaultDestinationAddress = '#LIMSLocationRecordEdit-View-Container';
			// @ts-ignore
			for (const pickList of this.manifest.PickLists || [])
			{
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
			}
			this.pict.views['PictSectionForm-LocationEdit'].rebuildCustomTemplate();
			this.initialized = true;
		}
		super.onBeforeRenderAsync(async () =>
		{
			try
			{
				this.pict.views['PictSectionForm-LocationEdit'].rebuildCustomTemplate();
				this.log.info('Location Details view rendered with Active Record', this.AppData.LocationDetails);

				// get the IDLocation from the router parameters
				const tmpGUIDLocation = this.pict.providers.LIMSRouter.currentView.split('/')[1];
				if (tmpGUIDLocation)
				{
					this.log.info('Location Details view opened with GUIDLocation', tmpGUIDLocation);
					// get the Location record by ID
					const tmpRecord = await this.pict.providers.LocationProvider.getLocationByGUID(tmpGUIDLocation);
					if (tmpRecord)
					{
						this.AppData.LocationDetails = tmpRecord;
						this.log.info('Location Details view opened with Location record', this.AppData.LocationDetails);
					}
					else
					{
						this.log.error('Location record not found for ID', tmpGUIDLocation);
					}
				}
			}
			catch (error)
			{
				this.log.error('Error in Location Details onBeforeRenderAsync:', error);
			}
			return pCallback();
		}, pRenderable);
	}

	/**
	 * Open the Location detail view for the selected Location to view the full details
	 * @param {number|string} pIDLocation - The ID of the Location to view
	 * @param {object} pLocationRecord - The Location record to view
	 * @param {string} pOpenTab - The tab to open when the Location detail view is shown
	 * @return {Promise<void>}
	 * @async
	 */
	async showLocationDetailView(pIDLocation, pLocationRecord, pOpenTab = 'Details')
	{
		// if a Location record is passed in, use it, otherwise get the Location record by ID
		if (pLocationRecord)
		{
			this.AppData.LocationDetails = Array.isArray(pLocationRecord) ? pLocationRecord[0] : pLocationRecord;
		}
		else
		{
			const tmpRecord = await this.pict.providers.LocationProvider.getLocationByID(pIDLocation);
			this.AppData.LocationDetails = tmpRecord;
		}
		// render the Location detail view
		await new Promise((resolve, reject)=>
		{
			this.renderAsync(() =>
			{
				this.log.info('Location Details View Rendered with Active Record', this.AppData.LocationDetails);
				resolve();
			});
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').ErrorCallback} fCallback
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		this.pict.views['PictSectionForm-LocationEdit'].render();
		this.pict.views['PictSectionForm-LocationEdit'].marshalToView();

		return super.onAfterRenderAsync(fCallback, pRenderable);
	}

	/**
	 * This method is used to handle the Print button click for building the print view.
	 * @return {void}
	 */
	printQRCodeLabel()
	{
		if (!this.AppData.LocationDetails)
		{
			this.log.error('No active Location to print QR Code for');
			return;
		}
		this.log.info('Printing Location Details');
		this.pict.providers.QRCodeProvider.printDecoratedEntity('Location', this.AppData.LocationDetails.QRCode);
	}

	goToEditView()
	{
		if (!this.AppData.LocationDetails)
		{
			this.log.error('[Location-Record-Edit] No active Location to edit');
			return;
		}
		this.log.info('[Location-Record-Edit] Going to Edit Location view for Location GUID:', this.AppData.LocationDetails.GUIDLocation);
		this.pict.providers.LIMSRouter.router.navigate(`/Location/${this.AppData.LocationDetails.GUIDLocation}/Edit`);
	}

	confirmDeleteLocation()
	{
		// prompt a confirmation modal to do the deletion
		this.fable.HeadlightModal.spawnModal({
			title: 'Delete Location',
			modalBodyTemplate: /*html*/`
			<div class="container column is-12">
				<p class="title is-5
				has-text-centered p-2 mb-5">
					<span class="icon">
						<i class="fa fa-fw fa-exclamation-triangle has-text-danger"></i>
					</span>
					<span> Are you sure you want to delete this Location?</span>
				</p>
				<p class="is-6 has-text-centered">This action is irreversible and will permanently delete</p>
				<p class="has-text-centered m-3"><strong>${ this.AppData.LocationDetails.Name }</strong></p>
				<p class="is-6 has-text-centered">Please click button below to confirm deletion or close this modal.</p>
			</div>`,
			modalFooterTemplate: /*html*/`
			<div class="buttons is-right">
				<button class="button is-danger is-soft" type="button" title="Cancel Deletion" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
					<span class="icon">
						<i class="fas fa-fw fa-times" aria-hidden="true"></i>
					</span>
					<span>Cancel</span>
				</button>
				<button class="button is-danger" type="button" title="Delete Location" onclick="_Pict.views.LIMSLocationRecordEdit.deleteLocation()">
					<span class="icon">
						<i class="fas fa-fw fa-trash" aria-hidden="true"></i>
					</span>
					<span>Delete Location</span>
				</button>
			</div>`,
			confirmText: 'Delete Location',
			cancelText: 'Cancel',
		});
	}

	deleteLocation()
	{
		if (!this.AppData.LocationDetails)
		{
			this.log.error('[Location-Record-Edit] No active Location to delete');
			return;
		}
		this.log.info('[Location-Record-Edit] Deleting Location ID:', this.AppData.LocationDetails.IDLocation);
		this.pict.HeadlightRestClient.deleteEntity('Location', this.AppData.LocationDetails.IDLocation, () =>
		{});
		this.pict.providers.LIMSRouter.router.navigate('/PSRS/Location/List');
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	toggleTabContent(event, pTabID)
	{
		// clear the active class from all tabs
		const tmpTabs = document.querySelectorAll('.tabs ul li');
		tmpTabs.forEach((tab) =>
		{
			tab.classList.remove('is-active');
		});
		// set the active class on the selected tab
		const tmpActiveTab = event.currentTarget;
		if (tmpActiveTab)
		{
			tmpActiveTab?.parentElement.classList.add('is-active');
		}
		// hide all the tab content
		const tmpTabContent = document.querySelectorAll('.tab-content');
		tmpTabContent.forEach((content) =>
		{
			content.classList.remove('is-active');
		});
		// show the selected tab content
		const tmpActiveTabContent = document.getElementById(`${pTabID}-Content`);
		if (tmpActiveTabContent)
		{
			tmpActiveTabContent.classList.add('is-active');
		}
	}

	async saveLocationChanges()
	{
		this.log.info('Saving Location changes');
		const tmpLocation = this.AppData.LocationDetails;
		// Remove field we shouldn't save.
		const removedFields = [ 'CreateDate', 'UpdateDate', 'DeleteDate', 'CreatingIDUser', 'DeletingIDUser', 'Deleted', 'UpdatingIDUser', 'ParentLocation' ];
		for (const r of removedFields)
		{
			delete tmpLocation[r];
		}
		// save the Location
		const tmpResult = await new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.updateEntity('Location', tmpLocation, (pError, pResult) =>
			{
				if (pError)
				{
					reject(pError);
				}
				resolve(pResult);
			});
		});
		if (tmpResult)
		{
			this.log.info('Location changes saved successfully');
			this.goToReadView();
			this.pict.views.HeadlightPanels.toast({ message: 'Location changes saved successfully', type: 'is-success' });
		}
		else
		{
			this.log.error('Error saving Location changes');
			this.pict.views.HeadlightPanels.toast({ message: 'Error saving Location changes', type: 'is-danger' });
		}
	}

	goToReadView(pEvent)
	{
		if (pEvent)
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
		}
		if (!this.AppData.LocationDetails)
		{
			this.log.error('No active Location to view');
			return;
		}
		this.log.info('Going to Read Location view for Location GUID:', this.AppData.LocationDetails.GUIDLocation);
		this.pict.providers.LIMSRouter.router.navigate(`/Location/${ this.AppData.LocationDetails.GUIDLocation }`);
	}

	handleFormSubmitAction(event)
	{
		event.preventDefault();
		event.stopPropagation();
		this.log.info('Location form submitted');

		this.saveLocationChanges();
	}
}

module.exports = LIMSLocationRecordEdit;

module.exports.default_configuration =
{
	ViewIdentifier: 'LIMSLocationRecordEdit',
	DefaultRenderable: 'LIMSLocationRecordEdit',
	DefaultDestinationAddress: '#LIMS-Application-Container',
	CSS: /*css*/`
		.tab-content {
			display: none;
		}
		.tab-content.is-active {
			display: block;
		}`,
	Templates:
	[
		{
			Hash: 'LIMSLocationRecordEdit-Wrapper',
			Template: /*html*/`
			<form class="container form" data-location-id="{~D:Record.IDLocation~}" onsubmit="_Pict.views.LIMSLocationRecordEdit.handleFormSubmitAction(event);">
				{~T:LIMSLocationRecordEdit-LocationHeader:AppData.LocationDetails~}
				<!-- Location Panel Tabs -->
				{~T:LIMSLocationRecordEdit-Panel-Tabs:AppData.LocationDetails~}
				<!-- LIMSLocationRecord Content > Tab Details View -->
				<div id="LIMSLocationRecordEditPanel-Details-Content" class="tab-content is-active">
					<div id="LIMSLocationRecordEdit-Details-Container">{~T:LIMSLocationRecordEdit-Tab-Details:AppData.LocationDetails~}</div>
				</div>
			</form>`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-Panel-Tabs',
			Template: /*html*/`
			<nav class="tabs is-right mt-2">	
				<ul>				
					<li class="is-active">
						<a id="LIMSLocationRecordEditPanel-Details-Tab" class="is-active" onclick="_Pict.views.LIMSLocationRecordEdit.toggleTabContent(event, 'LIMSLocationRecordPanel-Details')">
							<span class="icon">
								<i class="fa fa-fw fa-info-circle"></i>
							</span>
							<span class="icon-text">
								Details
							</span>
						</a>
					</li>
					<li>
						<a id="LIMSLocationRecordEditPanel-Print-Tab" onclick="_Pict.views.LIMSLocationRecordEdit.printQRCodeLabel()">
							<span class="icon">
								<i class="fa fa-fw fa-qrcode"></i>
							</span>
							<span class="icon-text">
								Print
							</span>
						</a>
					</li>
				</ul>
			</nav>`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-LocationHeader',
			Template: /*html*/`
			<div class="container columns has-background-text-soft is-mobile is-vcentered mb-0" style="min-height: 130px">
				<div class="column px-5">
					<p class="title is-4">
						{~TIfAbs:LIMSLocationRecordEdit-DatumValue-Name:Record:Record.Name^>^0~}
						{~TIfAbs:LIMSLocationRecordEdit-DatumValue-Name-Empty:Record:Record.Name^<=^0~}
					</p>
					<p class="subtitle is-6 has-text-text-50 mb-2">
						<span class="icon">
							<i class="fas fa-fw fa-qrcode fa-sm"></i>
						</span>
						<span class="icon-text">{~D:Record.QRCode~}</span>
					</p>
				</div>
				<div class="column is-3" style="flex-basis: content;">
					<figure class="image is-96x96 mr-1">{~QRCodeImage:Record.QRCode^96x96^Location^~}</figure>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-Tab-Details',
			Template: /*html*/`
			<!-- Placeholder for dynamic section -->
			<div id="LIMSLocationRecordEdit-View-Container" class="app-page-gutters-for-mobile px-5 mt-2"></div>
			{~T:LIMSLocationRecordEdit-Tab-Details-Buttons-Edit:AppData.LocationDetails~}`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-Tab-Details-Buttons-Edit',
			Template: /*html*/`
			<div class="columns px-3 m-0">
				<div class="column px-3 py-1 has-text-right">
					<button type="button" id="LIMSLocationRecordEdit-Tab-Details-Cancel-Button" class="button is-link is-soft" onclick="_Pict.views.LIMSLocationRecordEdit.goToReadView(event)">
						<span class="icon">
							<i class="fa fa-fw fa-times"></i>
						</span>
						<span class="icon-text">Cancel</span>
					</button>
					<button type="submit" id="LIMSLocationRecordEditPanel-Logs-Add-Button" class="button is-link">
						<span class="icon">
							<i class="fa fa-fw fa-save"></i>
						</span>
						<span class="icon-text">Save Changes</span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-EntityValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-DatumValue',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-DatumValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-DatumValue-Name',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-DatumValue-Name-Empty',
			Template: /*html*/`Unnamed Location #{~D:Record.IDLocation~}`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-DatumValue-Description',
			Template: /*html*/`{~D:Record.Description~}`,
		},
		{
			Hash: 'LIMSLocationRecordEdit-DatumValue-ParentLocation',
			Template: /*html*/`{~D:Record.ParentLocation.Name~}`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'LIMSLocationRecordEdit',
			TemplateHash: 'LIMSLocationRecordEdit-Wrapper',
			DestinationAddress: '#LIMS-Application-Container',
			RenderType: 'replace',
		},
	],
};
